import { Scroller } from './Scroller';

const targets = Array.from(
  document.querySelectorAll<HTMLAnchorElement>(
    'a[href^="#"]:not(.js-no-scroll)',
  ),
);
const scrollers = targets.map(x => new Scroller(x));

export { scrollers };
